import * as React from "react";
const SvgIcTriangleOutline = (props) => /* @__PURE__ */ React.createElement("svg", { height: 512, viewBox: "0 0 512 512", width: 512, xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("title", null), /* @__PURE__ */ React.createElement("polygon", { points: "48 448 256 64 464 448 48 448", style: {
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 32
} }));
export default SvgIcTriangleOutline;
